import React from 'react'
import Button from './Button'
import { PRICES } from '../consts/prices'
import PricesStyle from '../styles/PricesStyle'

const Prices = ({ pricesRef }) => {
  const prices = PRICES
  const content = prices.map(item => (
    <div className="column" key={item.key}>
      <h3>{item.title}</h3>
      <p>
        {item.description.split('\n').map((el, i) => (
          <span key={item.key + i}>
            {el}
            <br />
          </span>
        ))}
      </p>
      <div className="price">
        <h1>{item.price}</h1>
        <p>cena netto</p>
        <Button link="/app/?path=account" title="wypróbuj za darmo" />
      </div>
    </div>
  ))
  return (
    <PricesStyle ref={pricesRef}>
      <div className="container">{content}</div>
    </PricesStyle>
  )
}

export default Prices
